import type { FC } from 'react';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';
import { selectKeyframesByVersionIdMap } from '@iconik-io/shared-lib/src/redux/entities/selectors/keyframes';
import { findBestKeyframe } from '@iconik-io/shared-lib/src/utils/find_best_keyframe';
import { CheckboxField } from '@iconik-io/uad';

import Ellipsis from '../../components/ellipsis/ellipsis';
import { ICONS } from '../../icons/icon';
import { useAppSelector } from '../../store/react_redux_typed';
import IconButton from '../icon_button/icon_button';

import styles from './version_selector.module.css';

const VersionSelectorAssetItem: FC<{
  selectedItem: SearchItemEntity;
  latestVersionId: undefined | string;
  isExpandable?: boolean;
  onExpand?: () => void;
  isExpanded?: boolean;
  onSelectAllVersions: (value: boolean) => void;
  selectedItemsCount: number;
  itemsCount: number;
}> = ({
  selectedItem,
  latestVersionId,
  isExpandable,
  onExpand,
  isExpanded,
  onSelectAllVersions,
  itemsCount,
  selectedItemsCount,
}) => {
  const keyframeByVersionId = useAppSelector((state) =>
    selectKeyframesByVersionIdMap(state, selectedItem.id),
  );

  const thumbnailUrl = latestVersionId
    ? (findBestKeyframe(keyframeByVersionId[latestVersionId])?.url ?? undefined)
    : null;

  const isAllSelected = selectedItemsCount === itemsCount && itemsCount > 0;
  const isIndeterminate =
    selectedItemsCount > 0 && selectedItemsCount < itemsCount;

  return (
    <div id={selectedItem.title} className={styles.asset_item}>
      <CheckboxField
        isSelected={isAllSelected}
        isIndeterminate={isIndeterminate}
        onChange={(value) => {
          onSelectAllVersions(value);
        }}
      />

      <span>
        {selectedItemsCount}/{itemsCount}
      </span>

      <div
        className={styles.version_thumbnail}
        style={{
          backgroundImage: thumbnailUrl ? `url(${thumbnailUrl})` : undefined,
        }}
      />

      <Ellipsis
        componentProps={{
          className: styles.title,
        }}
        tooltipText={selectedItem.title}
      >
        {selectedItem.title}
      </Ellipsis>

      {isExpandable ? (
        <IconButton
          onClick={onExpand ?? undefined}
          className={styles.expand_button}
          icon={isExpanded ? ICONS.NavUp : ICONS.NavRight}
          aria-expanded={isExpanded}
          aria-controls={selectedItem.title}
        />
      ) : null}
    </div>
  );
};

export default VersionSelectorAssetItem;
